import classNames from "classnames";
import React from "react";

import { IValueProp } from "../models/value-props.interfaces";
import ValueProp from "./ValueProp";

import styles from "./ValuePropsBar.module.scss";

interface IProps {
    valueProps: IValueProp[];
    className?: string;
}

export const ValuePropsBar = (props: IProps): React.ReactNode => {
    const containerClasses = classNames(styles.container, props.className);
    const rootClasses = classNames(styles.root, props.className);

    return (
        <div className={containerClasses}>
            <ul className={rootClasses}>
                {props.valueProps.map((valueProp, i) => (
                    <ValueProp
                        key={i}
                        prop={valueProp}
                        className={props.className || ""}
                    />
                ))}
            </ul>
        </div>
    );
};
